import I18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEn from '../config/TranslationEn.json';
import translationMidwestEn from '../config/midwest/TranslationEnMidWest.json';

const TRANSLATIONS = {
  default: translationEn,
  MWE: translationMidwestEn,
  FET: translationMidwestEn
};

I18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEn },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export async function setOrgCode(orgCode) {
  await I18n.isInitialized; // guard: wait if init is still in progress

  const bundle = TRANSLATIONS[orgCode] ?? TRANSLATIONS.default;

  I18n.addResourceBundle('en', 'translation', bundle, true, true);

  // Trigger re-render in all useTranslation() consumers
  await I18n.changeLanguage('en');
}

export default I18n;